import {Routes} from '@angular/router';
import {AuctionsComponent} from '../auctions/auctions.component';
import {externalRedirectResolver} from '../shared/resolver/external-redirect.resolver';
import {ParkingComponent} from '../parking/parking.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    resolve: {redirect: externalRedirectResolver},
    component: AuctionsComponent,
    title: 'ProcessWay Landings'
  },
  {
    path: "auctions",
    component: AuctionsComponent,
    title: $localize`:@@routes.auctions.title:ProcessWay | Licytacje`,
    data: {
      theme: "auctions",
      logotypeUrl: "assets/auctions/logos/pw-licytacje-logo.svg",
      faviconUrl: "assets/favicons/auctions-favicon.ico",
      label: "ProcessWay for Leasing",
      contact: {
        phone: [
          "(22)3271580"
        ],
        email: [
          "licytacje@processway.pl"
        ]
      },
      title: $localize`:@@routes.auctions.data.title:ProcessWay Licytacje – nowa platforma aukcyjna cesji umów leasingowych`,
      meta: {
        description: $localize`:@@routes.auctions.meta.description:ProcessWay Licytacje to platforma dla firm i dealerów umożliwiająca bezpieczną sprzedaż i zakup pojazdów poleasingowych oraz cesji leasingu. Zapewnia przejrzyste licytacje, weryfikację ofert i kontrahentów oraz automatyczną obsługę dokumentów i płatności.`,
        title: $localize`:@@routes.auctions.meta.title:ProcessWay Licytacje | Cesje umów leasingowych & pojazdy poleasingowe`,
        image: "https://landing.processway.pl/assets/auctions/logos/pw-licytacje-logo.svg",
        url: "https://landing.processway.pl/auctions",
        type: "website",
        robots: "index,follow,max-image-preview:large",
        googlebot: "index,follow,indexifembedded"
      }
    }
  },
  {
    path: "autopark",
    component: ParkingComponent,
    title: $localize`:@@routes.autopark.title:ProcessWay | Plac depozytowy`,
    data: {
      theme: "parking",
      logotypeUrl: "assets/parking/logos/pw-autopark-logo.svg",
      faviconUrl: "assets/favicons/autopark-favicon.ico",
      label: "ProcessWay AutoPark",
      contact: {
        phone: [
          "+48793596718"
        ],
        email: [
          "autopark@processway.pl"
        ]
      },
      title: $localize`:@@routes.autopark.data.title:ProcessWay AutoPark – profesjonalny plac depozytowy i obsługa pojazdów flotowych`,
      meta: {
        description: $localize`:@@routes.autopark.meta.description:AutoPark ProcessWay to system do zarządzania placem depozytowym dla pojazdów flotowych, powindykacyjnych i poleasingowych. Zapewnia pełną obsługę logistyczną — od przyjęcia i inwentaryzacji po serwis, przygotowanie do sprzedaży i bezpieczeństwo infrastruktury. Przeznaczony dla firm leasingowych, flotowych i windykacyjnych.`,
        title: $localize`:@@routes.autopark.meta.title:ProcessWay AutoPark | Plac depozytowy pojazdów, logistyka i obsługa flot`,
        image: "https://landing.processway.pl/assets/parking/logos/pw-autopark-logo.svg",
        url: "https://landing.processway.pl/autopark",
        type: "website",
        robots: "index,follow,max-image-preview:large",
        googlebot: "index,follow,indexifembedded"
      }
    }
  },
  {
    path: "**",
    redirectTo: ''
  }
];
